import { ADMIN_API } from '../AdminAPI';
export function createJointVentureSettingService(api) {
    return {
        getJointVentureSetting() {
            return api.fetch(ADMIN_API.GET_JOINT_VENTURE_SETTING);
        },
        updateJointVentureSetting(data) {
            return api.fetch(ADMIN_API.POST_JOINT_VENTURE_SETTING, { data });
        }
    };
}
//# sourceMappingURL=JointVentureSettingService.js.map